<template>
  <div class="modal fade" id="AddPieceModal" tabindex="-1" role="dialog" ref="addPieceModalRef" aria-labelledby="tooltipmodal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ title }}</h4>
          <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <Form ref="pieceForm" @submit="addPiece" :validation-schema="pieceSchema">
            <div class="row">
              <div class="col-md-12 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Code <span class="text-danger">*</span>
                  </label>
                  <Field name="code" type="text" 
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le libellé"/>
                  <ErrorMessage name="code" class="text-danger"/>
                </div>
              </div>
              <div class="col-md-12 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Libelle <span class="text-danger">*</span>
                  </label>
                  <Field name="libelle" type="text" 
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer un libelle"/>
                  <ErrorMessage name="libelle" class="text-danger"/>
                </div>
              </div>
              <button class="btn btn-primary" type="submit">
                {{ btntext }}
              </button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from '@/services/ApiService';
import * as Yup from 'yup';
import { hideModal } from '@/utils/utils';
import { Piece } from '@/models/Piece';
import { error, success } from '@/utils/utils';
import { useRouter } from 'vue-router';

export default defineComponent({
  name: "AddPieceModal",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  props: {
    item: {
      type: Number,
      default: 0,
    }
  },
  setup(props, { emit }) {
    const pieceSchema = Yup.object().shape({
      libelle: Yup.string().required('Le libellé est obligatoire'),
      code:Yup.string().required('Le code est obligatoire'),
    });

    const pieceForm = ref<any>(null); 
    const addPieceModalRef = ref<null | HTMLElement>(null);
    const router = useRouter();
    const isUPDATE = ref(false);
    const title = ref("Ajouter une pièce");
    const btntext = ref('Ajouter');

    
    const btnTitle = async () => {
      if (isUPDATE.value) {
        title.value = "Modifier la pièce";
        btntext.value = "Modifier";
      } else {
        title.value = "Ajouter une pièce";
        btntext.value = "Ajouter";
      }
    };

 
    const getPiece = async (id: number) => {
      return ApiService.get("/pieces/" + id)
        .then(({ data }) => {
          const donnees = data.data;
          for (const key in donnees) {
            pieceForm.value?.setFieldValue(key, donnees[key]);
          }
          emit('openmodal', addPieceModalRef.value);
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    };


    watch(() => props.item, (newValue) => {
      if (newValue) {
        getPiece(newValue);
        isUPDATE.value = true;
        btnTitle();
      }
    });

 
    const addPiece = async (values: any, { resetForm }) => {
      values = values as Piece;
      if (isUPDATE.value) {
        ApiService.put("/pieces/" + values.id, values)
          .then(({ data }) => {
            if (data.code === 200) {
              success(data.message);
              resetForm();
              hideModal(addPieceModalRef.value);
              isUPDATE.value = false;
              btnTitle();
              emit('close');
            }
          })
          .catch(({ response }) => {
            error(response.data.message);
          });
      } else {
        ApiService.post("/pieces", values)
          .then(({ data }) => {
            if (data.code === 201) {
              success(data.message);
              resetForm();
              hideModal(addPieceModalRef.value);
              emit('close');
            }
          })
          .catch(({ response }) => {
            error(response.data.message);
          });
      }
    };

    const resetValue = () => {
      const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
      isUPDATE.value = false;
      formFields.forEach(field => {
        field.value = '';
      });
      btnTitle();
    };

    onMounted(() => {
     
    });

    return {
      pieceSchema,
      addPieceModalRef,
      addPiece,
      pieceForm,
      title,
      btntext,
      resetValue,
    };
  },
});
</script>